<template>
  <div class="fora">
    <div class="topo-header centro">
      <botao-voltar class="voltar" nomeRota="Respostas" />
      <h1>Visualizar Resposta</h1>
    </div>
    <div class="form centro">
      <div class="dados">
        <fieldset>
          <div class="dados">
            <div class="flexbox-3">
              <p class="item">Texto da Resposta:
                <span>{{ resposta.texto }}</span>
              </p>
              <p class="item">Status:
                <span>{{ resposta.ativo ? 'Ativo' : 'Inativo' }}</span>
              </p>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="bt-editar" v-if="podeEscrever('respostas')">
        <div class="div-center">
          <div :id="resposta.id">
            <router-link :to="{ name: 'RespostaEdit', params: { id: resposta.id } }">
              <button id="botao-editar">
                Editar
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div>
      <Footer
        :createdByLabel="'Criado por'"
        :criadoPor="resposta.criado_por"
        :lastUpdatedByLabel="'Última atualização feita por'"
        :atualizadoPor="resposta.atualizado_por"
        :emLabel="' em '"
        :SistemaLabel="'Sistema'"
        :created_at="resposta.created_at"
        :updated_at="resposta.updated_at"
      />
    </div>
  </div>
</template>

<script>
  import BotaoVoltar from "../BotaoVoltar.vue";
  import { parseISO, format } from "date-fns"
  import Footer from "../Footer.vue"

  export default {
    name: "ExibirResposta",
    props: {
      resposta: Object,
    },
    data() {      
      return {}
    },
    components: {
      BotaoVoltar,
      Footer,
    },
    methods: {      
      formatarDataHora: function (value) {
        if (!value) return '';
        return format(parseISO(value), "dd/MM/yyyy") + " às " + format(parseISO(value), "HH:mm:ss.");
      },
    },
  };
</script>

<style lang="scss" scoped>  
  .fora {
    padding: 1.25rem;
  }
  .form .dados .flexbox-3 {
    display: grid !important;
    grid-template-columns: 1.8fr 1fr !important;
    gap: 10rem !important;
  }
  .item {
    font-size: 1.1rem;
    font-weight: bold;
  }
  .item span {
    font-weight: normal;
    margin-left: 0.5rem;
  }
  .bt-editar {
    margin-top: 1.5rem;
    text-align: center;
  }
  #botao-editar {
    background-color: #005516;
    color: white;
    border: none;
    font-size: 1rem;
    padding: 0.4rem 2rem;
    border-radius: 2rem;
    cursor: pointer;
  }
  #botao-editar:hover {
    background-color: #4CAF50;
  }
</style>